import React, { useState } from 'react';
import axios from 'axios';
import './Security.css';
import { API, authHeadersOnly } from '../services/apiConfig';

function Security({ userId, onClose }) {
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [errors, setErrors] = useState({});
  const [submitMsg, setSubmitMsg] = useState({ text: '', type: '' });
  const errStyle = { color: '#c0392b', fontSize: '12px', marginTop: '4px' };

  const getPasswordStrength = (pwd) => {
    if (!pwd) return null;
    const strong = pwd.length >= 8 && /[!@#$%^&*(),.?":{}|<>]/.test(pwd) && /[0-9]/.test(pwd) && /[A-Z]/.test(pwd);
    const medium = pwd.length >= 8 && /[!@#$%^&*(),.?":{}|<>]/.test(pwd);
    if (strong) return { label: 'Strong', color: '#16a34a' };
    if (medium) return { label: 'Medium', color: '#d97706' };
    return { label: 'Weak', color: '#c0392b' };
  };

  const strength = getPasswordStrength(formData.newPassword);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const e2 = {};
    if (formData.newPassword.length < 8) e2.newPassword = 'Password must be at least 8 characters';
    else if (!/[!@#$%^&*(),.?":{}|<>]/.test(formData.newPassword)) e2.newPassword = 'Password must include at least one special character';
    if (formData.newPassword !== formData.confirmPassword) e2.confirmPassword = 'Passwords do not match';
    if (Object.keys(e2).length > 0) { setErrors(e2); return; }
    setErrors({});
    try {
      await axios.put(`${API}/api/auth/user/${userId}/password`, {
        currentPassword: formData.currentPassword,
        newPassword: formData.newPassword
      }, { headers: authHeadersOnly() });
      setSubmitMsg({ text: 'Password updated successfully!', type: 'success' });
      setFormData({ currentPassword: '', newPassword: '', confirmPassword: '' });
      setTimeout(() => setSubmitMsg({ text: '', type: '' }), 3000);
    } catch (error) {
      const msg = error.response?.status === 400
        ? 'Current password is incorrect.'
        : error.response?.data?.message || 'Failed to update password. Please try again.';
      setSubmitMsg({ text: msg, type: 'error' });
    }
  };

  return (
    <div className="security-overlay" onClick={onClose}>
      <div className="security-modal" onClick={(e) => e.stopPropagation()}>
        <div className="security-header">
          <h2>Security Settings</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <div className="security-content">
          <form className="security-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Current Password</label>
              <input
                type="password"
                value={formData.currentPassword}
                onChange={(e) => setFormData({...formData, currentPassword: e.target.value})}
                required
              />
            </div>

            <div className="form-group">
              <label>New Password</label>
              <input
                type="password"
                value={formData.newPassword}
                onChange={(e) => { setFormData({...formData, newPassword: e.target.value}); setErrors(p=>({...p,newPassword:''})); }}
                required
                minLength="8"
              />
              {formData.newPassword && strength && (
                <p style={{ fontSize: '12px', marginTop: '4px', color: strength.color, fontWeight: '600' }}>
                  Password strength: {strength.label}
                </p>
              )}
              {errors.newPassword && <p style={errStyle}>{errors.newPassword}</p>}
            </div>

            <div className="form-group">
              <label>Confirm New Password</label>
              <input
                type="password"
                value={formData.confirmPassword}
                onChange={(e) => { setFormData({...formData, confirmPassword: e.target.value}); setErrors(p=>({...p,confirmPassword:''})); }}
                required
                minLength="8"
              />
              {errors.confirmPassword && <p style={errStyle}>{errors.confirmPassword}</p>}
            </div>

            <div className="password-requirements">
              <p>Password must:</p>
              <ul>
                <li>Be at least 8 characters long</li>
                <li>Include at least one special character (!@#$%^&* etc.)</li>
                <li>Contain letters and numbers (recommended)</li>
              </ul>
            </div>

            {submitMsg.text && (
              <p style={{ color: submitMsg.type === 'success' ? '#16a34a' : '#c0392b', fontSize: '13px', marginBottom: '8px', fontWeight: '600' }}>
                {submitMsg.text}
              </p>
            )}
            <button type="submit" className="btn-save">Update Password</button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Security;
